/**
 * This is yuri-menu-sections script.js file
 */
import DispatchersMixin from '@/mixins/dispatchers';
import { generateTabPayload } from '@/use/menu.space';

export default {
    name: 'yuri-menu-sections',
    mixins: [DispatchersMixin],
    /**
     * @override
     */
    data() {
        return {
            sections: [],
            dummy_menu: [
                {
                    name: 'Dashboard',
                    active: true,
                    icon: 'fal fa-home',
                    route: {
                        name: 'dashboard'
                    }
                }
            ]
        };
    },
    methods: {
        // accedemos a un sección
        openSection(section) {
            if (this.$route.name === section.route.name) {
                return false;
            }

            try {
                const item = generateTabPayload(section.name, section.route.name);
                if (section.route.name !== 'dashboard') {
                    this.setMenuTab(item);
                } else {
                    this.$store.dispatch('yuriMenuStore/disableItemsMenu').then(() => {
                        this.$router.replace(item.route);
                        this.$store.dispatch('yuriMenuStore/setActiveItem', item);
                    });
                }
            } catch (error) {
                this.$toast.error(error);
            }
        }
    },
    computed: {
        /**
         * Returns active section
         * @return {Object} Sección activa
         */
        // activatedSection() {
        //     const section = this.menu.find(x => {
        //         return x.name === this.section.name;
        //     });
        //     return section || this.menu[0];
        // },
        /**
         * Returns active section
         * @return {Object} Sección activa
         */
        section() {
            return this.$store.getters['yuriMenuStore/section'];
        },
        /**
         * @override
         */
        hasMenutItemActive() {
            const menuActive = this.$store.getters['yuriMenuStore/activeItem'];
            return menuActive < 0 ? false : true;
        },
        /**
         * Gets user sections
         * @return {Object} Sections
         */
        menu() {
            const { sections } = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS')))));
            if (!sections) {
                return this.dummy_menu;
            }

            const dynamicSections = sections
                .filter(x => {
                    // Temporalmente ocultamos Groups y Permission sets del desplegable.
                    return !['GROUPS', 'PERMISSION_SET'].includes(x.key_name);
                })
                .map(x => {
                    const item = {
                        name: x.display_name,
                        active: false,
                        icon: x.fa_icon,
                        route: {
                            name: x.key_name.toLowerCase()
                        }
                    };
                    return item;
                });
            return this.dummy_menu.concat(dynamicSections);
        }
    }
};
